export class AssemblyVideo {
    title: string;
    entries: string;

    constructor(data: any = {}) {
        this.title = data.fields.title;
        this.entries = data.fields.file ? data.fields.file.url : undefined;
    }
}